import { initAdminAppState } from '@authy/lib-admin/appState'
import { createGlobalInstance } from '@authy/lib-client/utils/state'

import { AppState } from './AppState'

export const appState = createGlobalInstance('appState', () => new AppState())

export const initAppState = async () => {
    initAdminAppState(appState)
    return await appState.init()
}
